import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570e860e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row progress-bar",
  "data-testid": "progress-bar"
}
const _hoisted_2 = { class: "circle" }
const _hoisted_3 = { key: 1 }

import IconUI from '@/components/CommonUI/IconUI.vue'
import { useGettext } from 'vue3-gettext'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
  active: { type: Number, default: 1 },
},
  setup(__props) {

const { $gettext } = useGettext()

const progressLinks: string[] = [
  $gettext('Pick a Release'),
  $gettext('Add Writers'),
]



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(progressLinks, (text, index) => {
      return _createElementVNode("div", {
        key: index + text,
        class: _normalizeClass(["progress-link", { active: index + 1 === __props.active }])
      }, [
        _createElementVNode("span", _hoisted_2, [
          (index + 1 < __props.active)
            ? (_openBlock(), _createBlock(IconUI, {
                key: 0,
                name: "check",
                title: "check-icon"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(index + 1), 1))
        ]),
        _createTextVNode(_toDisplayString(text), 1)
      ], 2)
    }), 64))
  ]))
}
}

})